module.exports = __webpack_public_path__ + "assets/retina_IsoscelesTriangleAboutCircleDetailed.a4598c45e62171d5ecbd9e30e01c47ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_IsoscelesTriangleAboutCircleDetailed.png
// module id = 681
// module chunks = 0